import React from "react";
import { Button } from "reactstrap";

const CourseUnitSelector = ({
  semester,
  units,
  selectedUnitIds,
  onToggleUnit,
  onToggleAll
}) => {
  if (!units.length) return null;

  //const allSelected = units.every(u => selectedUnitIds.includes(u.id));
  const allSelected = units.every(u => selectedUnitIds.includes(Number(u.id)));

  //console.log("UNITS: ", units);
  console.log("selectedUnitIds:", selectedUnitIds);
  

  return (
    <div className="mb-3">
      <strong>{semester.code}</strong>
      <Button
        color="link"
        size="sm"
        onClick={() => {
          console.log(`Clique sur Tout cocher/décocher pour ${semester.code}`);
          onToggleAll(units, allSelected);
        }}
      >
        {allSelected ? "Tout décocher" : "Tout cocher"}
      </Button>

      <div className="d-flex flex-wrap gap-3 mt-1">
        {units.map(cu => (
          <div key={`${semester.id}-${cu.id}`} className="form-check">
            <input
              type="checkbox"
              id={`cu-${semester.id}-${cu.id}`}
              className="form-check-input"
              
              checked={selectedUnitIds.includes(Number(cu.id))}
              onChange={e => {
                console.log(`Clic sur l'UE: ${cu.title}, checked: ${e.target.checked}`);
                onToggleUnit(cu, e.target.checked);
              }}
            />
            <label className="form-check-label" htmlFor={`cu-${semester.id}-${cu.id}`}>
              {cu.title}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseUnitSelector;
